module.exports = __webpack_public_path__ + "assets/img/PREVENTA_img2.cb6e15b3.png";